import { useLiveQuery } from 'dexie-react-hooks';
import { Link } from 'react-router-dom';

import { countByStatus, useSyncStore } from '../sync/index.js';

/**
 * Постоянный индикатор в шапке — крупный, читается через пыльный экран
 * и в перчатках. Оператор должен видеть состояние отправки, не заходя никуда.
 */
export function SyncIndicator(): JSX.Element {
  const counts = useLiveQuery(() => countByStatus(), [], {
    pending: 0,
    sending: 0,
    rejected: 0,
    synced: 0,
  });
  const online = useSyncStore((state) => state.online);
  const phase = useSyncStore((state) => state.phase);

  const unsent = counts.pending + counts.sending;

  let label: string;
  let tone: string;

  // Отклонённые здесь намеренно не показываются: в шапке это была красная
  // плашка со словом, которое оператору ничего не объясняет. Разбор отклонений
  // ушёл в заметную полосу на самом кабинете, где есть место для причины.
  if (phase === 'unauthorized') {
    label = unsent > 0 ? `Нужен PIN · ${unsent}` : 'Нужен PIN';
    tone = 'bg-amber-500 text-black';
  } else if (!online) {
    label = unsent > 0 ? `Нет сети · ${unsent}` : 'Нет сети';
    tone = 'bg-amber-500 text-black';
  } else if (unsent > 0) {
    label = phase === 'sending' ? `Отправляю: ${unsent}` : `Ждёт отправки: ${unsent}`;
    tone = 'bg-amber-500 text-black';
  } else {
    label = 'Всё отправлено';
    tone = 'bg-emerald-600 text-white';
  }

  return (
    <Link
      to="/queue"
      className={`flex min-h-touch items-center rounded-xl px-4 py-2 text-base font-semibold ${tone}`}
    >
      {label}
    </Link>
  );
}
